import React from 'react';
import styled from 'styled-components';
import { selectDarkTheme } from '@utils/themes';

const Wrapper = styled.div`
  padding: 108px 60px 80px 60px;
  height: 100vh;

  * {
    color: ${({ theme }) => selectDarkTheme(theme).text};
  }
`;

export const Mission = () => {
  return <Wrapper>{/*<H5>Mission</H5>*/}</Wrapper>;
};
